const cacheObj = {};

function getFromCache(key) {
  return cacheObj[key];
}

function setCache(key, data) {
    cacheObj[key] = data;
}

export  {
  getFromCache,
  setCache
};
